/**
 * Les différents type d'infobulles
 */
export enum ToolTipType {
  None = 0,
  Text = 1,
  Link = 2,
}
